import React, { useEffect } from "react";
import { Card, Table, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Eye } from "react-bootstrap-icons";

function SMSCampaignDataIssueSummary({ campaignData }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const summary = useSelector(
        (state) => state?.smsCampaignReducer?.dataIssueSummary?.summary || {}
    );

    useEffect(() => {
        console.log("Summary : ", summary)
    }, [summary])

    const campaignUuid = campaignData?.campaignUuid;
    const campaignId = campaignData?.campaignId;

    // STOP rendering until campaignUuid and campaignId exist
    if (!campaignUuid || !campaignId) return null;

    const openDetails = (type) => {
        navigate(
            `/campaign/sms-campaign-report/${campaignUuid}/data-issues/${campaignId}/${type}`
        );
    };

    if (!summary || typeof summary !== "object") return null;

    return (
        <Card className="mb-4 shadow-sm">
            <Card.Header>
                <strong>Data Issue Summary</strong>
            </Card.Header>

            <Card.Body className="p-0">
                <Table striped bordered hover responsive className="mb-0 text-center">
                    <thead>
                        <tr style={{ backgroundColor: "#e0e0e0" }}>
                            {Object.keys(summary).map((type) => (
                                <th key={type}>
                                    {type.charAt(0).toUpperCase() + type.slice(1)}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {Object.entries(summary).map(([type, count]) => (
                                <td key={type} className="text-center align-middle">
                                    <div className="d-flex justify-content-center align-items-center gap-2">
                                        <span className="fw-medium">{count}</span>

                                        {count > 0 && (
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                className="rounded-circle d-flex justify-content-center align-items-center"
                                                style={{
                                                    width: "32px",
                                                    height: "32px",
                                                    padding: 0,
                                                }}
                                                onClick={() => openDetails(type)}
                                            >
                                                <Eye className="text-primary" />
                                            </Button>
                                        )}
                                    </div>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
}

export default SMSCampaignDataIssueSummary;
